import type { GuestlistGatewayApp } from "gateway-guestlist";
import { type AppClientOptions, appClient } from "./client";

// Client of the Guestlist app (ADR-287 §6, ADR-294): the Logto login of the internal users at /auth; crm's routes under
// /api/crm, the only domain it talks to (ADR-287 §2.7).

export function guestlistClient(options: AppClientOptions = {}) {
  const { api, root } = appClient<GuestlistGatewayApp>(options);
  return { api, auth: root.auth };
}
